import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { zonesList } from '@/mocks/homepage';

export default function Zones() {
  const { t } = useTranslation('homepage');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="zones" className="bg-soft-gray py-20 md:py-28 lg:py-32">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          {/* Left: Zones */}
          <div>
            <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-10 md:mb-14">
              {t('zones_h2')}
            </h2>

            <div className="flex flex-wrap items-center justify-start gap-3 md:gap-4">
              {zonesList.map((zone) => (
                <div
                  key={zone}
                  className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-sm hover:shadow-md transition-all duration-300"
                >
                  <i className="ri-map-pin-line text-copper" />
                  <span className="text-slate-primary font-medium text-sm md:text-base">
                    {zone}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Aerial%20panoramic%20view%20of%20the%20city%20of%20L%C3%A9vis%20Quebec%20Canada%20showing%20the%20Saint-Lawrence%20river%20and%20the%20Quebec%20City%20skyline%20across%20the%20water%2C%20residential%20neighborhoods%20with%20houses%20and%20green%20spaces%2C%20warm%20golden%20hour%20light%2C%20drone%20photography%20perspective%2C%20beautiful%20landscape%20with%20autumn%20colors%2C%20no%20text%20visible&width=800&height=500&seq=home-zone1&orientation=landscape"
              alt="Vue aérienne de Lévis et du fleuve Saint-Laurent — couvreur RBQ disponible dans tous les secteurs"
              className="w-full h-64 md:h-80 object-cover object-top"
              loading="lazy"
              width="800"
              height="500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}